import { useEffect } from 'react';
import { clearPrivateOrders } from 'app/client/modules/Order/hooks/storage';

/**
 * Drop the order data that may not outlive the session whenever the app runs
 * without a logged in user. Hooking into that state rather than into the logout
 * button covers an expired session too.
 */
export default (authenticated) => {
  useEffect(() => {
    if (authenticated) {
      return;
    }

    clearPrivateOrders();
  }, [authenticated]);
};
